// extracted by mini-css-extract-plugin
export default {"subHeader":"style--subHeader--4265eb"};